import { CustomerSummaryType } from "@/types/customer/customer.type";
import moment from "moment";

/***
 * Customer summary module
 */
export class CustomerSummary {
  public readonly id: string;
  public readonly last_name: string;
  public readonly first_name: string;
  public readonly comments: string;
  public readonly gender: string;
  public readonly phone_number: string;
  public readonly created_at: string;
  public readonly updated_at: string;

  public readonly address?: any;
  public readonly balance?: number;
  public readonly transactions?: number;
  public readonly net_sales?: number;
  public readonly average_sales?: number;
  public readonly last_transaction?: string;
  public readonly tags?: any;
  public static readonly MODULE_NAME: string = "customers/customer";

  constructor(data: CustomerSummaryType) {
    this.id = data.id;
    this.last_name = data.last_name || "";
    this.first_name = data.first_name || "";
    this.comments = data.comments;
    this.gender = data.gender;
    this.phone_number = data.phone_number;
    this.updated_at = data.updated_at;
    this.created_at = data.created_at;
    this.address = data.address || [];
    this.balance = data.balance || 0;
    this.transactions = data.transactions || 0;
    this.net_sales = data.net_sales || 0;
    this.average_sales = data.average_sales || 0;
    this.last_transaction = data.last_transaction;
    this.tags = data.tags;
  }

  /**
   * Customer full name
   * @return {string}
   */
  public fullName(): string {
    return `${this.first_name} ${this.last_name}`;
  }

  /**
   * Net sales formatted
   * @return {string}
   */
  public netSales(): string {
    const net_sales = this.net_sales || 0;
    return (net_sales / 1000).toFixed(3);
  }

  /**
   * Average sales formatted
   * @return {string}
   */
  public averageSales(): string {
    const averageSales = this.average_sales || 0;
    return (averageSales / 1000).toFixed(3);
  }

  /**
   * last transaction formatted
   * @return {string}
   */
  public lastTransaction(): string {
    return this.last_transaction ? moment(this.last_transaction).format("YYYY-MM-DD") : "";
  }

  /**
   * Prepare tags array
   * @return {Array<string>}
   */
  public tagsToChips(): Array<string> {
    return this.tags.length ? this.tags.map((tag: any) => tag.name) : [];
  }
}
